import { useMemo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { KeywordMatches } from '../KeywordMatches';
import PoweredByHarmony from '../PoweredByHarmony';
import {
  LATEST_SUMMARY_INDEX,
  selectTranscriptionForCall,
} from '../transcriptionSlice';
import CopySummary from './CopySummary';
import {
  LinearGradientBox,
  ConicGradientBox,
  IncidentBox,
  IncidentHeader,
  IncidentContent,
  CopySummaryWrapper,
  PoweredByHarmonyWrapper,
} from './IncidentSummary.styles';

/**
 * Call audio summary component that is displayed in the event pane's transcript tab.
 * @param {String} callerId - caller ID associated with the incident summary
 */
const IncidentSummary = ({ callerId = '', transcriptionOverride = null }) => {
  // TODO: Toggle glow animation effect based on incident summary API request.
  const [isGlowVisible, setIsGlowVisible] = useState(true);

  const summariesFromState = useSelector(
    state => selectTranscriptionForCall(callerId)(state).summaries,
  );

  const summaries = transcriptionOverride?.summaries || summariesFromState;

  const mostRecentSummary = useMemo(() => {
    if (summaries?.length) {
      return summaries[LATEST_SUMMARY_INDEX];
    }
    return null;
  }, [summaries]);

  // Use effect to update glow state when summary becomes final
  useEffect(() => {
    if (mostRecentSummary?.is_final) {
      setIsGlowVisible(false);
    }
  }, [mostRecentSummary]);

  if (!summaries?.length || !callerId) {
    return null;
  }

  const hasSummaryText =
    mostRecentSummary?.summary && mostRecentSummary.summary.length > 0;

  return (
    <>
      {hasSummaryText && (
        <LinearGradientBox data-name="incident-summary-card">
          <ConicGradientBox isGlowVisible={isGlowVisible}>
            <IncidentBox>
              <IncidentHeader>
                <PoweredByHarmonyWrapper>
                  <PoweredByHarmony showStar title="Call Audio Summary" />
                </PoweredByHarmonyWrapper>
                <CopySummaryWrapper>
                  <CopySummary summaryText={mostRecentSummary.summary} />
                </CopySummaryWrapper>
              </IncidentHeader>
              <IncidentContent data-name="incident-content">
                {mostRecentSummary.summary}
              </IncidentContent>
            </IncidentBox>
          </ConicGradientBox>
        </LinearGradientBox>
      )}
      {!transcriptionOverride && <KeywordMatches />}
    </>
  );
};

export default IncidentSummary;
